import styled from 'styled-components';
import { Tag } from 'antd';

export default styled(Tag)`
  &.ant-tag {
    cursor: default;
    margin: 0px;
    font-size: 10px;
  }
`
